import styled from 'styled-components';
import { Modal } from 'View/Component';
import { breakpoints, colors } from 'View/Theme';
import { asRem } from 'utils';
import { sterneClosingPopup } from 'img/closing_popup';

export const StyledClosingPopup = styled(Modal)`
  .modal-dialog {
    margin: 1rem auto;
    min-height: unset !important;

    @media (min-width: ${breakpoints.sm}) {
      max-width: ${asRem(700)} !important;
      margin: 1rem auto;
    }

    @media (min-width: ${breakpoints.md}) {
      max-width: ${asRem(860)} !important;
    }

    @media (min-width: ${breakpoints.lg}) {
      max-width: ${asRem(960)} !important;
    }
  }

  .modal-content {
    background-color: ${colors.sleep.blue.c700};
    color: ${colors.sleep.beige.c100};
    border-radius: ${asRem(16)};
    overflow: hidden;
    position: relative;
    border: none;
    min-height: unset !important;
  }

  .modal-body {
    padding: ${asRem(20)} 0 0;
    text-align: center;
    max-height: none !important;
    min-height: unset !important;

    @media (min-width: ${breakpoints.md}) {
      padding: ${asRem(10)} 0 0;
    }
    @media (min-width: ${breakpoints.lg}) {
      padding: ${asRem(20)} 0 0;
    }
  }

  .icon-wrapper,
  button.icon-wrapper,
  [class*='close'],
  [aria-label*='close'],
  [aria-label*='Close'] {
    background: none !important;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    opacity: 1 !important;
  }

  .icon-wrapper svg {
    display: none !important;
  }

  .icon-wrapper i::after {
    content: '✕' !important;
    font-size: ${asRem(28)} !important;
    font-weight: bold !important;
    font-style: normal !important;
    color: ${colors.sleep.beige.c100} !important;
    position: absolute !important;
    right: ${asRem(17)} !important;
    top: ${asRem(4)} !important;
    cursor: pointer !important;
    opacity: 1 !important;
  }

  .list-wrapper {
    padding: 0 ${asRem(8)};
    margin-bottom: ${asRem(24)};
    text-align: left;

    @media (min-width: ${breakpoints.md}) {
      text-align: center;
      padding: 0 ${asRem(30)};
    }

    a:hover {
      color: ${colors.sleep.red.c300} !important;
    }
  }

  .illustration-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: relative;
    margin: 0;
    overflow: visible;
  }

  .illustration-wrapper::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: -${asRem(80)};
    right: -${asRem(80)};
    height: 120%;
    background-image: url(${sterneClosingPopup});
    background-size: cover;
    background-position: bottom center;
    z-index: 0;
  }

  .illustration-wrapper img.siebenschlaefer {
    height: ${asRem(175)};
    width: auto;
    position: relative;
    z-index: 2;
    margin-bottom: ${asRem(-16)};
  }
`;
